<template>
  <!--  我的课程 -->
  <div v-loading="loading" class="content">
    <div v-if="courseList.length === 0">
      <div class="kongImg">
        <el-image
          :src="
            $common.getResourceUrl('pcweb/pcKongStatus/img_zhengshukong.png')
          "
        />
        <p>您还没有课程哦</p>
      </div>
    </div>
    <div v-else>
      <div v-for="(item, index) in courseList" :key="index" class="subject">
        <el-image class="img" fit="cover" :src="item.cover" />
        <div class="subjectContent">
          <div>
            <div class="title">{{ item.name }}</div>
            <div v-if="item.last_chapter" class="introduce">
              上次学到：
              <span>
                <span v-if="item.last_chapter.ident"
                  >{{ item.last_chapter.ident }}：</span
                >
                <span>{{ item.last_chapter.title }}</span>
              </span>
            </div>
            <div class="teacherName">
              <div v-for="(p, i) in item.teachers" :key="i">
                <el-image :src="p.headpic" />
                <span>{{ p.name }}</span>
              </div>
            </div>
          </div>
          <div>
            <el-button class="button" plain @click="goCourseTable(item)"
              >查看目录</el-button
            >
            <el-button
              class="button"
              plain
              type="primary"
              @click="goCourseDetails(item)"
            >
              <icon-svg icon-class="bofang" />
              {{ item.last_chapter ? '继续学' : '开始学' }}
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 分页条 -->
    <el-pagination
      v-if="page.page_last > 1"
      :current-page="page.page"
      layout="prev, pager, next"
      :page-size="page.limit"
      :total="page.total"
      @current-change="pageChange"
      @size-change="limitChange"
    />
  </div>
</template>
<script>
import { getSubjectList } from '@/network/request'
export default {
  name: 'MyCourses',
  props: {},
  data() {
    return {
      loading: false,
      courseList: [], // 课程列表
      page: {
        page: 1,
        limit: 6,
        page_last: 1,
        total: 0,
      },
    }
  },
  computed: {},
  watch: {},
  created() {
    this.getSubjectList()
  },
  mounted() {},
  methods: {
    // 获取我的课程列表
    async getSubjectList() {
      const res = await getSubjectList({
        page: this.page.page,
        limit: this.page.limit,
      })
      this.courseList = res.data.result.data
      this.page.total = res.data.result.total
      this.page.page_last = res.data.result.page_last
    },
    pageChange(e) {
      this.page.page = e
      this.getSubjectList()
    },
    limitChange(e) {
      this.page.limit = e
      this.page.page = 1
      this.getSubjectList()
    },
    goCourseTable(item) {
      const routerJump = this.$router.resolve({
        name: 'COURSE_TABLE',
        params: {
          id: item.id,
        },
      })
      window.open(routerJump.href, '_blank')
    },
    goCourseDetails(item) {
      const routerJump = this.$router.resolve({
        name: 'courseCatalogue',
        params: {
          id: item.id,
        },
      })
      // if (item.last_chapter)
      //   routerJump.href += '?chapter_id=' + item.last_chapter.id
      window.open(routerJump.href, '_blank')
    },
  },
}
</script>
<style lang="scss" scoped>
.content {
  padding: 25px;
  overflow-y: auto; // 关键
}

.kongImg {
  text-align: center;
  padding: 20px 0;

  .el-image {
    margin-bottom: 20px;
  }

  p {
    color: #8a8a8a;
  }
}

.subject {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  height: 150px;

  .img {
    width: 200px;
    height: 130px;
    background-color: #f9f9f9;
    border-radius: 6px;
    margin-right: 20px;
    overflow: hidden;
  }

  &:last-child {
    .subjectContent {
      border-bottom: none;
    }
  }
  .subjectContent {
    position: relative;
    height: 100%;
    flex: 1;
    display: flex;
    overflow: hidden;
    justify-content: space-between;
    border-bottom: 1px solid #f2f2f2;
    padding-top: 5px;
    padding-bottom: 5px;

    > div:first-child {
      flex: 1;
      margin-right: 30px;
      overflow: hidden;

      .title {
        font-size: 20px;
        color: #000000;
        margin-top: 7px;
        margin-bottom: 14px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .introduce {
        font-size: 14px;
        color: #828282;
        line-height: 30px;
        margin-bottom: 35px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        & > span {
          padding: 5px 12px;
          background-color: #f8f9fa;
          border-radius: 4px;
          box-shadow: 1px 1px 4px #eee;
        }
      }

      .teacherName {
        display: flex;
        align-items: center;
        font-size: 14px;
        margin-top: 18px;
        color: #828282;

        .el-image {
          width: 26px;
          height: 26px;
          border-radius: 50%;
        }

        > div {
          display: flex;
          align-items: center;
          margin-right: 10px;

          &:last-child {
            margin-right: 0;
          }

          > span {
            margin-left: 5px;
          }

          .el-avatar {
            width: 25px;
            height: 25px;
            border-radius: 50%;
            border: 0;
          }
        }
      }
    }

    > div:last-child {
      position: absolute;
      right: 0;
      bottom: 0;
      text-align: right;

      .button {
        height: 38px;
        line-height: 38px;
        border-radius: 6px;
        margin-bottom: 10px;
        padding: 0 14px;
        border: 0;

        &:first-child {
          padding: 0 6px;
        }
      }
    }
  }
}
</style>
